import { useState, useEffect } from 'react';
import { useRecoilState } from 'recoil';
// import { isDirectSubmitAnswerState } from '@/store/atom';
import { isDirectSubmitAnswerInquiryState } from '@/store/atom';
import { Button } from '@/components/atoms/NewPcButton';

import { Dialog, DialogContent } from '@/components/atoms/Dialog';
import { AnswerControllerProps } from './AnswerController';
import CheckedTrueIcon from '@/assets/icons/OrderDetails/checkbox_checked_true.svg?react';
import CheckedFalseIcon from '@/assets/icons/OrderDetails/checkbox_checked_false.svg?react';

const LOCAL_STORAGE_KEY = 'isDirectSubmitAnswerInquiry';

type SubmitButtonProps = Pick<AnswerControllerProps, 'handleRegister' | 'isLoading' | 'comment'>;

const SubmitButton = ({ handleRegister, isLoading, comment }: SubmitButtonProps) => {
  const [isDirectSubmit, setIsDirectSubmit] = useRecoilState(isDirectSubmitAnswerInquiryState);
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (saved !== null) setIsDirectSubmit(JSON.parse(saved));
  }, [setIsDirectSubmit]);

  const handleClick = () => {
    if (isDirectSubmit) {
      handleRegister?.();
    } else {
      setOpen(true);
    }
  };

  const handleConfirm = () => {
    if (checked) {
      setIsDirectSubmit(true);
      localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
    }
    setOpen(false);
    handleRegister?.();
  };

  return (
    <>
      <Button
        isLoading={isLoading}
        size={'small'}
        onClick={handleClick}
        disabled={isLoading || !comment.trim()}
      >
        답글 등록
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent noCloseBtn className="w-fit p-[30px]">
          <div className="flex flex-col gap-[20px]">
            <div className="flex flex-col gap-[4px]">
              <div className="flex text-gr-900 Title3S18">답변을 등록할게요</div>
              <div className="flex flex-col gap-[10px]">
                <div className="text-gr-700 Body5M14">
                  등록 이후 답변 수정 및 삭제가 필요할 경우
                  <br />
                  마켓 판매자 페이지에서 진행해 주세요
                </div>
                <button
                  type="button"
                  className="flex cursor-pointer items-center gap-[4px]"
                  onClick={() => setChecked((prev) => !prev)}
                  aria-pressed={checked}
                >
                  {checked ? (
                    <CheckedTrueIcon className="h-5 w-5" />
                  ) : (
                    <CheckedFalseIcon className="h-5 w-5" />
                  )}
                  <span className="text-gr-700 Body5M14">다음부터 바로 등록하기</span>
                </button>
              </div>
            </div>
            <div className=" flex gap-2">
              <Button
                variant="secondary"
                className="flex-1 py-[11px]"
                onClick={() => setOpen(false)}
                type="button"
              >
                취소
              </Button>
              <Button
                variant="solid"
                className="flex-1 py-[11px]"
                onClick={handleConfirm}
                type="button"
              >
                확인
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SubmitButton;
